export enum PaymentType {
    EXTRA = 'extra_bonus',
    STANDART = 'payment'
};